import { useContext } from "react";
import { SearchGroupContext } from "../../context";
import type { SourceObject } from "../useQuery/dto";
import type { UseSearchGroupProps } from "./dto";
/**
 * 获取上下文
 */
const useSearchGroup = <
  T extends SourceObject = any
>(): UseSearchGroupProps<T> => {
  const context = useContext(SearchGroupContext);

  return context;
};

export default useSearchGroup;
